export default "__VITE_ASSET__Cp7KuaL0__"